import { CONFIG } from "@/config";

export const Footer = () => (
  <footer data-testid="site-footer" className="bg-[#0A192F] text-white">
    <div className="max-w-7xl mx-auto px-6 md:px-12 py-14 md:py-20 grid grid-cols-1 md:grid-cols-3 gap-10 md:gap-16">
      <div>
        <div className="font-display text-2xl md:text-3xl font-medium tracking-tight">
          {CONFIG.businessName}
        </div>
        <p className="mt-4 text-white/70 leading-relaxed max-w-sm text-sm">
          {CONFIG.tagline}
        </p>
      </div>
      <div>
        <div className="text-[10px] tracking-[0.24em] uppercase text-white/60 mb-4">Explore</div>
        <ul className="space-y-3 text-sm">
          <li><a href="#reviews" className="hover:text-white/70 transition-colors">Reviews</a></li>
          <li><a href="#credentials" className="hover:text-white/70 transition-colors">Credentials</a></li>
          <li><a href="#services" className="hover:text-white/70 transition-colors">Services</a></li>
          <li><a href="#contact" className="hover:text-white/70 transition-colors">Contact</a></li>
        </ul>
      </div>
      <div>
        <div className="text-[10px] tracking-[0.24em] uppercase text-white/60 mb-4">Contact</div>
        <ul className="space-y-3 text-sm">
          <li><a href={`mailto:${CONFIG.contactEmail}`} className="hover:text-white/70 transition-colors">{CONFIG.contactEmail}</a></li>
          <li><a href={`tel:${CONFIG.contactPhone.replace(/\s/g, "")}`} className="hover:text-white/70 transition-colors" data-testid="footer-phone-link">{CONFIG.contactPhone}</a></li>
          <li><a href="/admin" className="text-white/40 hover:text-white/70 transition-colors text-xs" data-testid="footer-admin-link">Consultant login</a></li>
        </ul>
      </div>
    </div>
    <div className="border-t border-white/10">
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-6 text-xs text-white/50 flex flex-col md:flex-row justify-between gap-3">
        <div>© {new Date().getFullYear()} {CONFIG.businessName}. All rights reserved.</div>
        <div>Tutoring · Literacy · Academic consulting</div>
      </div>
    </div>
  </footer>
);
